"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminExchangeCurrenciesSchema = exports.AdminExchangeListSchema = exports.AdminExchangeSchema = exports.AdminExchangeQuerySchema = void 0;
const zod_1 = require("zod");
const exchange_1 = require("../exchange");
const wallet_1 = require("../wallet");
const withdrawals_1 = require("../withdrawals");
const DAY = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
/** A `YYYY-MM-DD` UTC calendar day; rejects dates that don't exist, e.g. `2026-02-30`. */
const CalendarDay = zod_1.z.string().regex(DAY).refine((s) => {
    const d = new Date(`${s}T00:00:00.000Z`);
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}, { message: 'not a calendar day' });
exports.AdminExchangeQuerySchema = zod_1.z
    .object({
    status: exchange_1.ExchangeStatusSchema.optional(),
    userId: zod_1.z.uuid().optional(),
    /** Same semantics as the users list: digits = telegram id, `@` = email prefix, else username or email prefix. */
    q: zod_1.z.string().trim().min(1).max(254).optional(),
    /** Destination currency, e.g. `UAH`. */
    toAlpha3: zod_1.z.string().min(3).max(3).optional(),
    /** Inclusive UTC calendar days on `createdAt`. */
    createdFrom: CalendarDay.optional(),
    createdTo: CalendarDay.optional(),
    cursor: zod_1.z.string().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).catch(100).default(20),
})
    .refine((q) => !q.createdFrom || !q.createdTo || q.createdFrom <= q.createdTo, {
    message: 'createdTo must not be before createdFrom',
    path: ['createdTo'],
});
exports.AdminExchangeSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    status: exchange_1.ExchangeStatusSchema,
    userId: zod_1.z.uuid(),
    userEmail: zod_1.z.string(),
    userUsername: zod_1.z.string().nullable(),
    /** BigInt in the database; a string on the wire so no precision is lost in JSON. */
    userTelegramId: zod_1.z.string(),
    exchangerOrderId: zod_1.z.number().int(),
    exchangerHash: zod_1.z.string(),
    chainCode: zod_1.z.string(),
    chainName: zod_1.z.string(),
    symbol: zod_1.z.string(),
    decimals: zod_1.z.number().int().min(0),
    fromAmount: wallet_1.AtomicAmountSchema,
    toAmount: wallet_1.AtomicAmountSchema,
    toDecimals: zod_1.z.number().int().min(0),
    toAlpha3: zod_1.z.string(),
    toCurrencyType: zod_1.z.string(),
    toCurrencyName: zod_1.z.string(),
    rate: exchange_1.DecimalStringSchema,
    recipientMasked: zod_1.z.string().nullable(),
    paymentAddress: zod_1.z.string().nullable(),
    supportEmail: zod_1.z.string().nullable(),
    /** The exchanger's raw integer status and error code, as last seen. */
    exchangerStatus: zod_1.z.number().int().nullable(),
    exchangerErrorCode: zod_1.z.number().int().nullable(),
    errorCode: zod_1.z.string().nullable(),
    withdrawalId: zod_1.z.uuid().nullable(),
    withdrawalStatus: withdrawals_1.WithdrawalStatusSchema.nullable(),
    txHash: zod_1.z.string().nullable(),
    explorerUrl: zod_1.z.url().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    paidAt: zod_1.z.iso.datetime().nullable(),
    processingAt: zod_1.z.iso.datetime().nullable(),
    completedAt: zod_1.z.iso.datetime().nullable(),
});
exports.AdminExchangeListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.AdminExchangeSchema),
    nextCursor: zod_1.z.string().nullable(),
    /** How many orders are `failed` right now, regardless of the filter: money left and the exchanger closed the order. */
    failedCount: zod_1.z.number().int().min(0),
});
/** Distinct destination currencies (`toAlpha3`) ever used, sorted; feeds the list filter. */
exports.AdminExchangeCurrenciesSchema = zod_1.z.object({ items: zod_1.z.array(zod_1.z.string()) });
//# sourceMappingURL=exchanges.js.map